import axiosInstance from './axiosInstance';

export const getAllProducts = async () => {
  const response = await axiosInstance.get('/products');
  return response.data;
};

export const getProductById = async (id) => {
  const response = await axiosInstance.get(`/products/${id}`);
  return response.data;
};

export const getProductsByCategory = async (categoryId) => {
  const response = await axiosInstance.get(`/products/category/${categoryId}`);
  return response.data;
};

export const getProductsByClass = async (productClass) => {
  const response = await axiosInstance.get(`/products/class/${productClass}`);
  return response.data;
};

export const searchProducts = async (keyword) => {
  const response = await axiosInstance.get(`/products/search?keyword=${keyword}`);
  return response.data;
};

export const getAllCategories = async () => {
  const response = await axiosInstance.get('/categories');
  return response.data;
};

export const getProductReviews = async (productId) => {
  const response = await axiosInstance.get(`/reviews/product/${productId}`);
  return response.data;
};